/** Texto en mayúsculas, sin acentos y con espacios simples (como normalizeText_ del código actual). */
export function normalizeText(s: unknown): string {
  return String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
}

/** Importe escrito por una persona o un banco: '1.870,97', '1870,97', '1870.97', '-12' → número (NaN si no válido). */
export function parseEsAmount(v: unknown): number {
  if (typeof v === 'number') return v;
  let s = String(v ?? '').trim().replace(/\s|€/g, '');
  if (!s) return NaN;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if ((s.match(/\./g) ?? []).length > 1) s = s.replace(/\./g, '');
  return /^-?\d+(\.\d+)?$/.test(s) ? Number(s) : NaN;
}

/** Redondeo de importes de ficheros (mismo criterio que el importador actual). */
export function roundAmount(n: number): number {
  return Math.round(n * 100) / 100;
}
